// https://github.com/moment/moment/issues/3650
export default function interopDefault(m: any) {
  return m.default || m;
}



// WEBPACK FOOTER //
// ./components/_util/interopDefault.ts